import styled, {css} from 'styled-components'

export const StyledPrivacyPolicyPage = styled.main(
    ({theme: {spacing, palette}}) => css`
        min-height: 100vh;
        background-color: ${palette.neutral['50']};
        padding: ${spacing * 10}px ${spacing * 4}px;
    `
)

export const StyledPrivacyPolicyContent = styled.article(
    ({theme: {spacing, palette}}) => css`
        max-width: 800px;
        margin: 0 auto;
        padding: ${spacing * 10}px;
        background-color: ${palette.neutral.white};
        border: 1px solid ${palette.neutral['200']};
        border-radius: 12px;
        display: flex;
        flex-direction: column;
        gap: ${spacing * 6}px;

        /* The document is a long legal text: keep paragraphs comfortably
           readable and lists aligned with the surrounding copy. */
        p {
            line-height: 1.6;
        }

        ul {
            display: flex;
            flex-direction: column;
            gap: ${spacing * 2}px;
            padding-left: ${spacing * 5}px;
            list-style: disc;
        }

        li {
            line-height: 1.6;
        }

        a {
            color: ${palette.primary['600']};
            text-decoration: underline;
            word-break: break-word;
        }
    `
)

export const StyledPrivacyPolicySection = styled.section(
    ({theme: {spacing}}) => css`
        display: flex;
        flex-direction: column;
        gap: ${spacing * 3}px;
    `
)

export const StyledPrivacyPolicyHeader = styled.header(
    ({theme: {spacing, palette}}) => css`
        display: flex;
        flex-direction: column;
        gap: ${spacing * 2}px;
        padding-bottom: ${spacing * 6}px;
        border-bottom: 1px solid ${palette.neutral['200']};
    `
)

/* Mirrors the PDF letterhead: the foundation logo on the left, the ISO
   certification mark on the right. */
export const StyledLogosRow = styled.div(
    ({theme: {spacing}}) => css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: ${spacing * 4}px;
        margin-bottom: ${spacing * 4}px;
    `
)

export const StyledFoundationLogo = styled.img`
    height: 80px;
    width: auto;
`

export const StyledCertificationLogo = styled.img`
    height: 56px;
    width: auto;
`

export const StyledDpoTable = styled.table(
    ({theme: {spacing, palette, typography}}) => css`
        ${typography.textSm};
        width: 100%;
        border-collapse: collapse;
        text-align: left;

        th,
        td {
            padding: ${spacing * 2}px ${spacing * 3}px;
            border: 1px solid ${palette.neutral['200']};
        }

        th {
            font-weight: 500;
            color: ${palette.neutral['700']};
            background-color: ${palette.neutral['50']};
        }

        td {
            color: ${palette.neutral['600']};
        }
    `
)

export const StyledTableScroll = styled.div`
    width: 100%;
    overflow-x: auto;
`
